import {clamp01, lerp} from "./math";

export interface IPoint {
    x: number;
    y: number;
}

export interface IRect {
    left: number;
    top: number;
    width: number;
    height: number;
}

export const getDistance = (a: IPoint, b: IPoint): number => Math.hypot(b.x - a.x, b.y - a.y);

export const reflectPoint = (pivot: IPoint, point: IPoint): IPoint => ({x: 2 * pivot.x - point.x, y: 2 * pivot.y - point.y});

export const mixPoints = (a: IPoint, b: IPoint, weightB: number): IPoint => ({x: lerp(a.x, b.x, weightB), y: lerp(a.y, b.y, weightB)});

const cross = (origin: IPoint, a: IPoint, b: IPoint) => (a.x - origin.x) * (b.y - origin.y) - (a.y - origin.y) * (b.x - origin.x);

const getDistanceToSegment = (point: IPoint, a: IPoint, b: IPoint) => {
    const lengthSquared = (b.x - a.x) ** 2 + (b.y - a.y) ** 2;
    const t = lengthSquared > 0 ? clamp01(((point.x - a.x) * (b.x - a.x) + (point.y - a.y) * (b.y - a.y)) / lengthSquared) : 0;

    return getDistance(point, mixPoints(a, b, t));
};

export const getConvexPolygonSignedDistance = (polygon: IPoint[], point: IPoint): number => {
    const edges = polygon.map((vertex, index) => [vertex, polygon[(index + 1) % polygon.length]] as const);
    const sides = edges.map(([a, b]) => Math.sign(cross(a, b, point)));
    const isInside = sides.some((side) => side !== 0) && (sides.every((side) => side >= 0) || sides.every((side) => side <= 0));
    const edgeDistance = Math.min(...edges.map(([a, b]) => getDistanceToSegment(point, a, b)));

    return isInside ? -edgeDistance : edgeDistance;
};
import {clamp01, lerp} from "./math";

export interface IPoint {
    x: number;
    y: number;
}

export interface IRect {
    left: number;
    top: number;
    width: number;
    height: number;
}

export const getDistance = (a: IPoint, b: IPoint): number => Math.hypot(b.x - a.x, b.y - a.y);

export const reflectPoint = (pivot: IPoint, point: IPoint): IPoint => ({x: 2 * pivot.x - point.x, y: 2 * pivot.y - point.y});

export const mixPoints = (a: IPoint, b: IPoint, weightB: number): IPoint => ({x: lerp(a.x, b.x, weightB), y: lerp(a.y, b.y, weightB)});

const cross = (origin: IPoint, a: IPoint, b: IPoint) => (a.x - origin.x) * (b.y - origin.y) - (a.y - origin.y) * (b.x - origin.x);

const getDistanceToSegment = (point: IPoint, a: IPoint, b: IPoint) => {
    const lengthSquared = (b.x - a.x) ** 2 + (b.y - a.y) ** 2;
    const t = lengthSquared > 0 ? clamp01(((point.x - a.x) * (b.x - a.x) + (point.y - a.y) * (b.y - a.y)) / lengthSquared) : 0;

    return getDistance(point, mixPoints(a, b, t));
};

export const getConvexPolygonSignedDistance = (polygon: IPoint[], point: IPoint): number => {
    const edges = polygon.map((vertex, index) => [vertex, polygon[(index + 1) % polygon.length]] as const);
    const sides = edges.map(([a, b]) => Math.sign(cross(a, b, point)));
    const isInside = sides.some((side) => side !== 0) && (sides.every((side) => side >= 0) || sides.every((side) => side <= 0));
    const edgeDistance = Math.min(...edges.map(([a, b]) => getDistanceToSegment(point, a, b)));

    return isInside ? -edgeDistance : edgeDistance;
};
